class OrganizerComponent {
    constructor() {
        this.typeId = OrganizerComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
OrganizerComponent.id = 2053;
export default OrganizerComponent;
//# sourceMappingURL=OrganizerComponent.js.map